import { useQuery } from '@tanstack/react-query'
import { supabase } from '../../api'

const getServiceTypes = async () => {
    const { data, error } = await supabase
        .from('service_type')
        .select(`*`)

    if (error) {
        throw new Error(error.message)
    }

    return data
}

export default function useGetServiceTypes() {
    return useQuery({
        queryKey: ['useGetServiceTypes'],
        queryFn: () => getServiceTypes(),
        staleTime: 0,
    })
}
